// Mail público de soporte (formulario de contacto → POST /api/contact + SMTP backend)
export const SUPPORT_EMAIL = 'contsuite@gmail.com';
